import {
	CHECK_PROJECT_ROUTE,
	PROJECT_DETAIL_ROUTE,
	USER_DETAIL_ROUTE,
	WEB_CHECK_DETAIL_ROUTE,
} from './consts';

export const userConfig = {
	route: USER_DETAIL_ROUTE,
	columns: [
		{ key: 'first_name', label: 'Vorname' },
		{ key: 'last_name', label: 'Nachname' },
		{ key: 'email', label: 'Email' },
		{ key: 'is_admin', label: 'Admin' },
	],
};

export const projectConfig = {
	route: PROJECT_DETAIL_ROUTE,
	columns: [
		{ key: 'project_name', label: 'Projektname' },
		{ key: 'project_url', label: 'URL' },
		{ key: 'is_permanent', label: 'Permanent' },
		{ key: 'is_finished', label: 'Abgeschlossen' },
	],
	has_check_action: true,
	check_route: CHECK_PROJECT_ROUTE,
};

export const checksConfig = {
	route: WEB_CHECK_DETAIL_ROUTE,
	columns: [
		{ key: 'check_name', label: 'Check-Name' },
		{ key: 'check_method', label: 'Check-Methode' },
		{ key: 'is_mandatory', label: 'Obligatorisch' },
	],
};
